import { createRoot, type Root } from "react-dom/client";
import { createElement } from "react";
import { SingleEmbed } from "../single/SingleEmbed";
import { PlaylistEmbed } from "../playlist/PlaylistEmbed";
import { ReelsEmbed } from "../reels/ReelsEmbed";
import { parseSingleProps, parsePlaylistProps, parseReelsProps } from "./parse";

class CCSingle extends HTMLElement {
  private root: Root | null = null;

  static observedAttributes = [
    "data-api-key",
    "data-video-id",
    "data-src",
    "data-poster",
    "data-title",
    "data-description",
    "data-thumbnail-storyboard-url",
    "data-duration",
    "data-sponsor",
    "data-overlays",
    "data-autoplay",
    "data-muted",
    "data-moment-nav-behavior",
  ];

  connectedCallback() {
    this.root = createRoot(this);
    this.update();
  }

  disconnectedCallback() {
    this.root?.unmount();
    this.root = null;
  }

  attributeChangedCallback() {
    if (this.root) this.update();
  }

  private update() {
    this.root!.render(createElement(SingleEmbed, parseSingleProps(this)));
  }
}

class CCPlaylist extends HTMLElement {
  private root: Root | null = null;

  static observedAttributes = [
    "data-api-key",
    "data-playlist-id",
    "data-videos",
    "data-overlays",
    "data-initial-index",
    "data-page-size",
    "data-max-videos",
  ];

  connectedCallback() {
    this.root = createRoot(this);
    this.update();
  }

  disconnectedCallback() {
    this.root?.unmount();
    this.root = null;
  }

  attributeChangedCallback() {
    if (this.root) this.update();
  }

  private update() {
    this.root!.render(createElement(PlaylistEmbed, parsePlaylistProps(this)));
  }
}

class CCReels extends HTMLElement {
  private root: Root | null = null;

  static observedAttributes = [
    "data-api-key",
    "data-playlist-id",
    "data-videos",
    "data-overlays",
    "data-page-size",
    "data-max-videos",
  ];

  connectedCallback() {
    this.root = createRoot(this);
    this.update();
  }

  disconnectedCallback() {
    this.root?.unmount();
    this.root = null;
  }

  attributeChangedCallback() {
    if (this.root) this.update();
  }

  private update() {
    this.root!.render(createElement(ReelsEmbed, parseReelsProps(this)));
  }
}

export function registerElements() {
  if (typeof customElements === "undefined") return;
  if (!customElements.get("seeen-video"))
    customElements.define("seeen-video", CCSingle);
  // seeen-single is kept as a backward-compatible alias
  if (!customElements.get("seeen-single"))
    customElements.define("seeen-single", class extends CCSingle {});
  if (!customElements.get("seeen-playlist"))
    customElements.define("seeen-playlist", CCPlaylist);
  if (!customElements.get("seeen-reels"))
    customElements.define("seeen-reels", CCReels);
}
